import { UserRoles } from "./types"

export const USERS_PREFIX = "@USERS/"
export const FETCH_USERS = `${USERS_PREFIX}FETCH_USERS`
export const FETCH_USER = `${USERS_PREFIX}FETCH_USER`
export const FETCH_USER_COMPANIES = `${USERS_PREFIX}FETCH_USER_COMPANIES`

export const USER_ROLES_LIST = [
  {
    value: UserRoles.RECYCLER,
    label: "Recycling",
  },
  {
    value: UserRoles.RECYCLER_AND_CONVERTER,
    label: "Recycling and Converting",
  },
  {
    value: UserRoles.CONVERTER,
    label: "Converting",
  },
  {
    value: UserRoles.AUDITOR,
    label: "Auditor",
  },
  {
    value: UserRoles.RECOVINYL_REGIONAL_REPRESENTATIVE,
    label: "Recovinyl & VinylPlus National Network Representative",
  },
  {
    value: UserRoles.SORTER,
    label: "Sorting",
  },
  {
    value: UserRoles.SORTER_AND_RECYCLER,
    label: "Sorting and Recycling",
  },
  // {
  //   value: UserRoles.SECTOR_ASSOCIATION_REPRESENTATIVE,
  //   label: 'Sector Association Representative',
  // },
]

export const PER_PAGE = [
  { label: "5", value: 5 },
  { label: "10", value: 10 },
  { label: "15", value: 15 },
  { label: "20", value: 20 },
  { label: "All", value: 99999 },
]
